/**
 * Complete the Look — expand/collapse variant panel per card (inline mode).
 */

function setCardExpanded(card, expanded) {
  if (!card) return;

  card.dataset.collapsed = expanded ? 'false' : 'true';

  const expandBtn = card.querySelector('[data-ctl-expand]');
  const addBtn = card.querySelector('[data-ctl-add]');
  const panel = card.querySelector('[data-ctl-panel]');

  if (expandBtn) {
    expandBtn.classList.toggle('hidden', expanded);
    expandBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  if (addBtn) {
    addBtn.classList.toggle('hidden', !expanded);
  }

  if (panel) {
    panel.classList.toggle('hidden', !expanded);
    panel.classList.toggle('flex', expanded);
  }

  updateCtlSliderHeight(card);
}

function updateCtlSliderHeight(card) {
  const sliderBlock = card?.closest('[data-slider-block]');
  if (!sliderBlock) return;

  const sync = () => {
    const swiper = window.getSliderBlockInstance?.(sliderBlock)?.swiper;
    if (!swiper) return;
    if (swiper.params.autoHeight) {
      swiper.updateAutoHeight(0);
    } else {
      swiper.update();
    }
  };

  requestAnimationFrame(() => requestAnimationFrame(sync));
}

function collapseOtherCards(activeCard) {
  const root = activeCard?.closest('.product-complete-the-look');
  if (!root) return;

  root.querySelectorAll('[data-complete-the-look-card]').forEach((card) => {
    if (card !== activeCard) {
      setCardExpanded(card, false);
    }
  });
}

function refreshCtlQuickAdd(root = document) {
  root.querySelectorAll('.product-complete-the-look quick-add-component').forEach((component) => {
    if (typeof component.reloadProductData === 'function') {
      component.reloadProductData();
    }
  });
}

function initCompleteTheLook(root = document) {
  root.querySelectorAll('[data-complete-the-look-card]').forEach((card) => {
    if (card.dataset.ctlInit === 'true') return;
    card.dataset.ctlInit = 'true';

    const expandBtn = card.querySelector('[data-ctl-expand]');
    if (!expandBtn) return;

    expandBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isCollapsed = card.dataset.collapsed !== 'false';
      if (isCollapsed) {
        collapseOtherCards(card);
      }
      setCardExpanded(card, isCollapsed);
    });
  });

  refreshCtlQuickAdd(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCompleteTheLook());
} else {
  initCompleteTheLook();
}

document.addEventListener('shopify:section:load', (event) => {
  initCompleteTheLook(event.target);
});

window.initCompleteTheLook = initCompleteTheLook;
